import { Button, Tag } from 'antd';
import React from 'react';

interface Props {
  name: string;
  active: boolean;
  count: number;
  onClick: () => void;
}

export function ButtonFilter({ name, active, count, onClick }: Props) {
  return (
    <Button
      style={{
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
        borderRadius: 0,
        borderWidth: 3,
        marginLeft: 5,
        borderColor: active ? '#40a9ff' : '',
      }}
      onClick={onClick}
    >
      {name || ''}
      <Tag
        color="#e8f9fe"
        style={{
          backgroundColor: '#fff',
          color: '#999',
          minWidth: 25,
          boxShadow: '0 0 0 1px #d9d9d9 inset',
          marginLeft: 7,
          borderRadius: 10,
          textAlign: 'center',
        }}
      >
        {count || 0}
      </Tag>
    </Button>
  );
}
